import { Box, CircularProgress, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { FontStyle, Panels, Slug, navPaddingTop, userStr } from "../constants";
import { useDispatch, useSelector } from "react-redux";
import MessagesSidebar from "../components/ChatComponents/MessagesSidebar";
import ChatPanel from "../components/ChatComponents/ChatPanel";
import * as apiService from "../service/ApiService";
import NoMessagesScreen from "../components/ChatComponents/NoMessagesScreen";
import { UrlParam, recruiterIdFromUrl, recruiterIdToUrl } from "../utils/utils";
import { useNavigate } from "react-router-dom";
import {
  failLocalMessage,
  newChatMessage,
  selectChat,
  setChatInput,
  successLocalMessage,
} from "../utils/actionUtils";

const styles = {
  outer: {
    paddingTop: navPaddingTop,
    width: "100%",
    height: "100vh",
  },
  inner: {
    width: "100%",
    height: "100%",
    // backgroundColor: "red",
  },
  container: {
    backgroundColor: "#fff",
    height: "100%",
    // minHeight: "calc(100vh)",
    width: "100%",
    overflow: "hidden",
  },
  headerPanel: {
    // borderRadius: Panels.borderRadius,
    backgroundColor: Panels.backgroundColor,
    // boxShadow: Panels.boxShadow,
    padding: Panels.padding,
    ...FontStyle.logo,
    fontSize: "24px",
    textAlign: "center",
    // textAlign: "left",
    px: 2,
    width: "100%",
    boxShadow: "0px 2px 4px rgb(0 0 0 / 10%)",
  },
};
const InboxPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const messages = useSelector((state) => state.messages);
  const [dataReady, setDataReady] = React.useState(false);
  const allChats = messages.allChats;
  const loggedIn = auth.testing
    ? true
    : auth.accountData.loginToken !== null &&
      auth.accountData.contactInfo !== null;
  const queryParameters = new URLSearchParams(window.location.search);
  const paramRecruiterId = queryParameters.get(UrlParam.recruiterId);
  const convertedRecruiterId = recruiterIdFromUrl(paramRecruiterId);
  useEffect(() => {
    // if convertedRecruiterId exists and messages.allChats contains it (and recip not already selected), set the recipient
    if (!convertedRecruiterId || !allChats) return;

    if (convertedRecruiterId !== messages.recipient?.userId) {
      const newChat = allChats.find(
        (chat) => chat.recipient.userId === convertedRecruiterId
      );
      console.log("select diff chat", convertedRecruiterId, newChat);
      if (newChat) {
        selectChat(dispatch, newChat);
      }
    } else {
      console.log(
        "already selected. update?",
        convertedRecruiterId,
        allChats,
        messages.history
      );
      if (messages.history.length && messages.history.at(-1).serverId) {
        allChats.forEach((chat) => {
          if (chat.recipient.userId === convertedRecruiterId) {
            const lastMessage = chat.history.at(-1);
            if (lastMessage.serverId) {
              if (lastMessage.serverId > messages.history.at(-1).serverId) {
                console.log(
                  "will selectChat update from allChats",
                  lastMessage,
                  messages.history.at(-1)
                );
                selectChat(dispatch, chat);
              }
            }
          }
        });
      }
    }
  }, [convertedRecruiterId, allChats]);
  useEffect(() => {
    if (!loggedIn) return;
    if (allChats !== null) {
      setDataReady(true);
    } else {
      // apiService.getChats(dispatch, { ...auth.accountData }, {});
    }
  }, [loggedIn, allChats]);
  // useEffect(() => {
  //   // if messages.recipient is set, check fullyLoaded
  //   // if not fullyLoaded, request the chat history
  //   console.log("message change", messages.recipient, messages.fullyLoaded);
  //   if (messages.recipient && !messages.fullyLoaded) {
  //     console.log("requesting chat history", messages.recipient);
  //     apiService.getFullChat(
  //       dispatch,
  //       { ...auth.accountData, recruiterId: messages.recipient.userId },
  //       {}
  //     );
  //   }
  // }, [messages.recipient, messages.fullyLoaded]);
  useEffect(() => {
    // set the url param to the recipient
    if (messages.recipient) {
      const recruiterId = recruiterIdToUrl(messages.recipient.userId);
      navigate({
        pathname: Slug.inbox + "/",
        search: `?${UrlParam.recruiterId}=${recruiterId}`,
      });
    }
  }, [messages.recipient]);

  if (!dataReady) {
    return (
      <Stack direction="column" sx={styles.outer}>
        <CircularProgress />
      </Stack>
    );
  }
  const onSend = () => {
    const recruiterId = messages.recipient.userId;
    const message = messages.input;
    if (!message) return;
    const localId = messages.numLocalMessages;
    const newMessage = {
      userId: userStr,
      //2023-05-28 23:38:00
      dt: new Date().toISOString().slice(0, 19).replace("T", " "),
      text: message,
      localId,
      waitingForServer: true,
    };
    newChatMessage(dispatch, newMessage);
    setChatInput(dispatch, "");
    apiService.messageBasic(
      dispatch,
      {
        ...auth.accountData,
        recruiterId,
        message,
      },
      {
        handleSuccess: (data) => {
          console.log("success", data);
          successLocalMessage(dispatch, localId, recruiterId, data.data.msg_id);
        },
        handleError: (data) => {
          console.log("fail", data);
          failLocalMessage(dispatch, localId, recruiterId);
        },
      }
    );
  };

  return (
    <Stack sx={styles.outer} direction="row">
      {allChats.length > 0 ? (
        <Stack sx={styles.inner} direction="row">
          <MessagesSidebar />
          {messages.recipient && (
            <Stack
              sx={styles.container}
              direction="column"
              alignItems="center"
              justifyContent="flex-start">
              <Box
                sx={
                  styles.headerPanel
                }>{`${messages.recipient.firstName} ${messages.recipient.lastName}`}</Box>
              <ChatPanel onSend={onSend} />
            </Stack>
          )}
        </Stack>
      ) : (
        <NoMessagesScreen />
      )}
    </Stack>
  );
};

export default InboxPage;
